import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper/core';
import 'swiper/css';
SwiperCore.use([Navigation]);

export default class UspCarousel {
    constructor (sliderElement) {
        if (!sliderElement) return;

        this.sliderElement = sliderElement;
        this.wrapper = this.sliderElement.closest('.js-usp-carousel-wrapper');
        this.arrowNext = this.wrapper ? this.wrapper.querySelector('.swiper-button-next') : null;
        this.arrowPrev = this.wrapper ? this.wrapper.querySelector('.swiper-button-prev') : null;
        this.init();
    }

    init() {
        new Swiper(this.sliderElement, {
            slidesPerView: 1,
            spaceBetween: 24,
            speed: 400,
            watchOverflow: true,
            centerInsufficientSlides: true,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev
            },
            on: {
                init: () => {
                    if (this.wrapper) this.wrapper.classList.add('swiper-initialized');
                }
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 48
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 72
                },
                1700: {
                    slidesPerView: 4,
                    spaceBetween: 108
                }
            }
        });
    }
}
